/* ============================
   START: TESTIMONIALS CAROUSEL
   ============================ */
// Testimonials Carousel - Drag/Swipe with Auto-play
document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.sn-testimonials-track');
  if (!track) return;

  const prevBtn = document.querySelector('.sn-prev');
  const nextBtn = document.querySelector('.sn-next');
  const prevTxt = document.querySelector('.sn-prev-txt');
  const nextTxt = document.querySelector('.sn-next-txt');

  const cards = Array.from(track.children);
  if (cards.length === 0) return;

  let currentIndex = 0;
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  let autoPlayInterval = null;
  const autoPlayDelay = 4000; // 4 seconds

  // Get number of visible cards based on screen size
  function getVisibleCards() {
    return window.matchMedia('(max-width: 768px)').matches ? 1 : 3;
  }

  // Get card width including gap
  function getCardWidth() {
    const firstCard = cards[0];
    const cardWidth = firstCard.offsetWidth;
    const trackStyle = window.getComputedStyle(track);
    const gap = parseFloat(trackStyle.gap) || 24;
    return cardWidth + gap;
  }

  // Update position with animation
  function updateCarousel(animate = true) {
    const cardWidth = getCardWidth();
    const offset = -currentIndex * cardWidth;
    
    track.classList.remove('dragging');
    if (animate) {
      track.classList.add('animating');
    } else {
      track.classList.remove('animating');
    }
    
    track.style.transform = `translateX(${offset}px)`;
    currentTranslate = offset;
    prevTranslate = offset;
    
    setTimeout(() => {
      track.classList.remove('animating');
    }, 500);
  }

  // Move to next slide (infinite loop)
  function goToNext() {
    const visibleCards = getVisibleCards();
    const maxIndex = cards.length - visibleCards;
    
    currentIndex++;
    if (currentIndex > maxIndex) {
      currentIndex = 0; // Loop back to start
    }
    
    updateCarousel(true);
  }

  // Move to previous slide (infinite loop)
  function goToPrev() {
    const visibleCards = getVisibleCards();
    const maxIndex = cards.length - visibleCards;
    
    currentIndex--;
    if (currentIndex < 0) {
      currentIndex = maxIndex; // Jump to end
    }
    
    updateCarousel(true);
  }

  // Auto-play functions
  function startAutoPlay() {
    stopAutoPlay();
    autoPlayInterval = setInterval(() => {
      goToNext();
    }, autoPlayDelay);
  }

  function stopAutoPlay() {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = null;
    }
  }

  // Button event handlers
  function handleNextClick(e) {
    e.preventDefault();
    stopAutoPlay();
    goToNext();
    startAutoPlay();
  }

  function handlePrevClick(e) {
    e.preventDefault();
    stopAutoPlay();
    goToPrev();
    startAutoPlay();
  }

  // Attach button listeners
  if (nextBtn) nextBtn.addEventListener('click', handleNextClick);
  if (prevBtn) prevBtn.addEventListener('click', handlePrevClick);
  if (nextTxt) nextTxt.addEventListener('click', handleNextClick);
  if (prevTxt) prevTxt.addEventListener('click', handlePrevClick);

  // Drag/Swipe functionality
  function getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  function dragStart(event) {
    stopAutoPlay();
    isDragging = true;
    startPos = getPositionX(event);
    animationID = requestAnimationFrame(animation);
    track.classList.add('dragging');
    
    if (event.type === 'mousedown') {
      event.preventDefault();
    }
  }

  function dragMove(event) {
    if (isDragging) {
      const currentPosition = getPositionX(event);
      const diff = currentPosition - startPos;
      currentTranslate = prevTranslate + diff;
    }
  }

  function dragEnd() {
    if (!isDragging) return;
    
    isDragging = false;
    cancelAnimationFrame(animationID);
    
    const movedBy = currentTranslate - prevTranslate;
    const cardWidth = getCardWidth();
    const threshold = cardWidth / 4;

    // Determine direction based on drag distance
    if (movedBy < -threshold) {
      goToNext();
    } else if (movedBy > threshold) {
      goToPrev();
    } else {
      // Snap back to current position
      updateCarousel(true);
    }

    startAutoPlay();
  }

  function animation() {
    if (isDragging) {
      track.style.transform = `translateX(${currentTranslate}px)`;
      requestAnimationFrame(animation);
    }
  }

  // Mouse events
  track.addEventListener('mousedown', dragStart);
  track.addEventListener('mousemove', dragMove);
  track.addEventListener('mouseup', dragEnd);
  track.addEventListener('mouseleave', () => {
    if (isDragging) dragEnd();
  });

  // Touch events
  track.addEventListener('touchstart', dragStart, { passive: false });
  track.addEventListener('touchmove', dragMove, { passive: true });
  track.addEventListener('touchend', dragEnd);

  // Prevent context menu on drag
  track.addEventListener('contextmenu', (e) => e.preventDefault());

  // Pause on hover (desktop only)
  track.addEventListener('mouseenter', () => {
    if (window.matchMedia('(min-width: 769px)').matches) {
      stopAutoPlay();
    }
  });

  track.addEventListener('mouseleave', () => {
    if (window.matchMedia('(min-width: 769px)').matches && !isDragging) {
      startAutoPlay();
    }
  });

  // Handle window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const visibleCards = getVisibleCards();
      const maxIndex = cards.length - visibleCards;
      if (currentIndex > maxIndex) {
        currentIndex = maxIndex;
      }
      updateCarousel(false);
    }, 250);
  });

  // Initialize carousel
  updateCarousel(false);
  startAutoPlay();
});
/* ============================
   END: TESTIMONIALS CAROUSEL
   ============================ */

// ============================================
// WHY HD SECTION - EXISTING FUNCTIONALITY
// ============================================

(function() {
  const prev = document.querySelector('.whyhd-prev');
  const next = document.querySelector('.whyhd-next');
  const prevTxt = document.querySelector('.whyhd-prev-txt');
  const nextTxt = document.querySelector('.whyhd-next-txt');
  const slides = document.querySelectorAll('.whyhd-slide');
  let index = 0;

  if (!slides.length) return;

  function updateWhyHDNavigationIcons(currentIndex, totalSlides) {
    // Static buttons - no dynamic icon changes
    // Images are now managed through Liquid template settings
    return;
  }

  function show(i) {
    const prevIndex = index;
    index = (i + slides.length) % slides.length;
    slides.forEach((el, idx) => {
      el.classList.toggle('active', idx === index);
      // ensure non-active are positioned absolute and hidden for animation
      if (idx !== index) {
        el.style.pointerEvents = 'none';
      } else {
        el.style.pointerEvents = 'auto';
      }
    });
    updateWhyHDNavigationIcons(index, slides.length);
  }

  function onPrev() { show(index - 1); }
  function onNext() { show(index + 1); }

  if (prev) prev.addEventListener('click', onPrev);
  if (next) next.addEventListener('click', onNext);
  if (prevTxt) prevTxt.addEventListener('click', onPrev);
  if (nextTxt) nextTxt.addEventListener('click', onNext);
  
  // Initialize icons on load
  updateWhyHDNavigationIcons(index, slides.length);
  show(index);
})();

// ============================================
// FAQ ACCORDION - EXISTING FUNCTIONALITY
// ============================================

(function () {
  function initFAQAccordion() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');
    if (!accordionHeaders.length) return;

    // Prevent double-binding if this script is included multiple times
    if (window.__SNFAQInit) return;
    window.__SNFAQInit = true;

    // Set initial heights based on active state
    accordionHeaders.forEach(header => {
      const idx = header.getAttribute('data-toggle');
      const cnt = document.querySelector(`[data-content="${idx}"]`);
      if (!cnt) return;
      if (cnt.classList.contains('active')) {
        cnt.style.maxHeight = cnt.scrollHeight + 'px';
      } else {
        cnt.style.maxHeight = '0px';
      }
    });

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const toggleIndex = this.getAttribute('data-toggle');
        const content = document.querySelector(`[data-content="${toggleIndex}"]`);
        const item = this.parentElement;
        const icon = this.querySelector('.accordion-icon img');
        
        if (!content) return;

        // Toggle active class
        item.classList.toggle('active');
        content.classList.toggle('active');

        // Update icon
        if (icon) {
          if (content.classList.contains('active')) {
            icon.src = 'https://cdn.shopify.com/s/files/1/0897/0148/2800/files/minus.png';
            icon.alt = 'Collapse';
          } else {
            icon.src = 'https://cdn.shopify.com/s/files/1/0897/0148/2800/files/plus_ad5a0f5a-5768-4ddf-b310-ca0348207bcb.png';
            icon.alt = 'Expand';
          }
        }

        // Animate height
        if (content.classList.contains('active')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0px';
        }
      });
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQAccordion);
  } else {
    initFAQAccordion();
  }
})();